import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import { useSiteConfigState, useStore } from '~/store/composable';

interface ICta {
  text: string;
  href: string;
  requirement: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NodesHeroVideo',
  setup(__props) {

const { i18n } = useContext();
// const { state: { profile } } = useStore();
// const loggedIn = computed(() => profile.user.loggedIn);
const siteConfigState = useSiteConfigState();

const shouldShowFilmNodeBuyPage = computed(() => {
  return siteConfigState?.value?.data?.shouldShowFilmNodeBuyPage || false;
});

const ctaPrimary = computed<ICta | undefined>(() => {
  return {
    text: i18n.t('common.cta.buyNode') as string,
    href: `/nodes/film-node/buy`,
    requirement: shouldShowFilmNodeBuyPage.value,
  };
});

const ctaSecondary = computed<ICta | undefined>(() => {
  // return {
  //   text: `Exchange Film Pass`,
  //   href:
  //     '/inventory/nfts/item?id=0x036e00000000000000000000000000000000&network=ETHEREUM&collection=Gala%20Film',
  //   requirement: loggedIn.value,
  // };

  return undefined;
});

const showCtas = computed(
  () => ctaPrimary?.value?.requirement || ctaSecondary?.value?.requirement,
);

return { __sfc: true,i18n, siteConfigState, shouldShowFilmNodeBuyPage, ctaPrimary, ctaSecondary, showCtas }
}

})